import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BildungsangebotTerminDetail } from '../../../../../model';

@Component({
  selector: 'now-wbsuche-lib-veroeffentlichungsinformationen',
  templateUrl: './veroeffentlichungsinformationen.component.html',
  styleUrls: ['./veroeffentlichungsinformationen.component.scss'],
  imports: [DatePipe]
})
export class VeroeffentlichungsinformationenComponent {
  @Input()
  public termin!: BildungsangebotTerminDetail;
}
